import { render, staticRenderFns } from "./WPGroup.vue?vue&type=template&id=07e8de6b"
import script from "./WPGroup.vue?vue&type=script&lang=ts"
export * from "./WPGroup.vue?vue&type=script&lang=ts"
import style0 from "./WPGroup.vue?vue&type=style&index=0&id=07e8de6b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports